import moment from "moment"
import {FormID} from "../interfaces"

const formatDateMonthDayYear = (date) => moment(date).format(" MMMM D [,] YYYY")

const formatStandarUSDate = (date) => moment(date).format(" MM/DD/YYYY")

const FORMS_PDF: FormID[] = ["enrollment_application"]

const REFILL_FORMS: FormID[] = ["enrollment_agreement", "opt_outs"]

const formatDateOrdinalSuffixes = (date) => {
    const standarUSDate = formatStandarUSDate(date)

    const dateObj = new Date(standarUSDate)
    const day = dateObj.getDate()
    const month = dateObj.toLocaleString("default", {month: "long"})
    const year = dateObj.getFullYear()

    const nthNumber = (number) => {
        if (number > 3 && number < 21) return "th"
        switch (number % 10) {
            case 1:
                return "st"
            case 2:
                return "nd"
            case 3:
                return "rd"
            default:
                return "th"
        }
    }

    const dateFormatted = `${month} ${day}${nthNumber(day)}` // without the year
    // const dateFormatted = `${month} ${day}${nthNumber(day)}, ${year}` // plus the year at the end

    return dateFormatted
}

const removeJsonDataForms = (currentJsonDataForms) => {
    return Object.keys(currentJsonDataForms)
        .filter((key) => !REFILL_FORMS.includes(key as FormID))
        .reduce((obj, key) => {
            obj[key] = currentJsonDataForms[key]
            return obj
        }, {})
}

const isEnableSubmitButton = (currentJsonDataForms) => {
    const filledForms = FORMS_PDF.length
    const jsonFormsKeys = Object.keys(currentJsonDataForms)
    let counter = 0
    for (let i = 0; i < jsonFormsKeys.length; i++) {
        const elementKey = jsonFormsKeys[i]
        if (FORMS_PDF.includes(elementKey as FormID)) counter += 1
    }
    return counter === filledForms ? false : true
}

const sizeCurrentFoms = (currentJsonDataForms) => {
    const jsonFormsKeys = Object.keys(currentJsonDataForms)
    let counter = 0
    for (let i = 0; i < jsonFormsKeys.length; i++) {
        const elementKey = jsonFormsKeys[i]
        if (FORMS_PDF.includes(elementKey as FormID)) counter += 1
    }
    return counter
}

const ALL_FORMS_IN_TABS = [
    "application_career_information",
    "enrollment_application",
    "application_upload_docs",
    "payment",
    "submission"
]

const FORMS_IDS = {
    application_career_information: "application_career_information",
    enrollment_application: "enrollment_application",
    payment: "payment",
    submission: "submission"
}

export {
    formatDateMonthDayYear,
    formatStandarUSDate,
    formatDateOrdinalSuffixes,
    removeJsonDataForms,
    isEnableSubmitButton,
    sizeCurrentFoms,
    FORMS_PDF,
    ALL_FORMS_IN_TABS,
    FORMS_IDS
}
